// extracted by mini-css-extract-plugin
export default {"inline":"ExternalBrandLogo-module__inline--_7kS7"};